module.exports = __webpack_public_path__ + "assets/tag.fd44919f.svg";